import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzAssignPolicyWebComponent } from './component/GzAssignPolicyWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { AssignPolicyHelper } from './helpers/assign.policy.helper';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { PolicyAssignationType } from './component/types';
import { NetworkPopUpFooterContentWebComponent } from '../NetworkPopUpFooterContentWebComponent';

export class AssignPolicyPopUp extends NetworkBasePopUp<GzAssignPolicyWebComponent> {
  protected title = translateFn('Assign policy');
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: true };

  protected customSetup() {
    this.popUpFooterContent = new NetworkPopUpFooterContentWebComponent();
    this.popUpFooterContent.confirmButtonDisabled = this.hasEnforcedTargets();

    this.popUpContent = new GzAssignPolicyWebComponent();
    this.popUpContent.targets = this.data.targets || [];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    // component targets might be updated, this.data.targets !== this.popUpContent.targets
    const targets = this.popUpContent.targets;
    const protectedEntitiesViewTypes = AssignPolicyHelper.getProtectedEntitiesViewTypes(targets);
    const formValue = this.popUpContent.getFormValue();

    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.EPS,
        endpoint: 'PolicyTemplates',
        method: 'assignPolicyToProtectedEntities',
        payload: {
          enforced: formValue.enforced,
          policyId: formValue.assignationType === PolicyAssignationType.CUSTOM ? formValue.policyId : null,
          protectedEntitiesViewTypes,
        },
      });

      if (response?.success) {
        this.showCustomToast(translateFn('Policy assignment successfully saved.'));
      } else {
        this.showErrorToastNotification(translateFn('Cannot save the policy assignment.'));
      }
    } catch (e) {
      this.showErrorToastNotification(translateFn('Cannot save the policy assignment.'));
    }
  }

  private hasEnforcedTargets(): boolean {
    let result = false;

    for (const target of this.data.targets || []) {
      if (target.activePolicy?.inheritedFrom?.id && target.activePolicy?.enforced) {
        result = true;
        break;
      }
    }

    return result;
  }
}
